
















































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { RestaurantsApi, GenresApi, UGCsApi } from "@/services/api-service";
import { EnvelopedGenresData, UpdateRestaurant, Restaurant } from "@/api/api";
import { edDays, EditStatus, ObjectKey } from "@/types";
import AuthModule from "@/store/auth";
import RestaurantModule from "@/store/restaurant";
import { Prefectures } from "@/constants";
import GenreModule from "@/store/genre";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import FormModal from "@/components/forms/FormModal.vue";
import { ja } from "vuejs-datepicker/dist/locale";

@Component({
  components: {
    CTooltip,
    FormModal,
  },
})
export default class RRestaurantEditForm extends Vue {
  private get me() {
    return AuthModule.me as null | Restaurant;
  }

  private get ja() {
    return ja;
  }

  private mounted() {
    RestaurantModule.commitRegisterStatus(EditStatus.Edit);
    this.getGenres();
    this.setFormValue();
  }

  @Watch("me")
  private setFormValue() {
    this.form = Object.assign(this.form, this.me);
    this.edFormOrderable = Object.assign(this.edFormOrderable, this.me?.edOnlineOrderableTime);
    this.edFormAcceptable = Object.assign(this.edFormAcceptable, this.me?.edAcceptableTime);
    this.holidays = Object.assign(this.holidays, this.me?.restaurantHolidays);
    if (this.me?.genres) {
      this.me.genres.forEach(genre => {
        if (!genre.id) {
          return;
        }
        this.checkedGenres[genre.id] = true;
      });
    }
  }

  private async getGenres() {
    const genresRes = await GenresApi.instance.getGenres();
    const { genres } = genresRes.data.data as EnvelopedGenresData;
    if (genres) {
      GenreModule.commitGenres(genres);
    } else {
      console.log("Genre not found");
    }
  }

  private get genres() {
    return GenreModule.genres;
  }

  private get edDays() {
    return edDays;
  }

  private edFormAcceptable: ObjectKey = {
    mon: [{ start: null, end: null }],
    tue: [{ start: null, end: null }],
    wed: [{ start: null, end: null }],
    thu: [{ start: null, end: null }],
    fri: [{ start: null, end: null }],
    sat: [{ start: null, end: null }],
    sun: [{ start: null, end: null }],
  };

  private edFormOrderable: ObjectKey = {
    mon: [{ start: null, end: null }],
    tue: [{ start: null, end: null }],
    wed: [{ start: null, end: null }],
    thu: [{ start: null, end: null }],
    fri: [{ start: null, end: null }],
    sat: [{ start: null, end: null }],
    sun: [{ start: null, end: null }],
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private holidays: any = [{ day: null }];

  private addHoliday() {
    this.holidays.push({ day: null });
  }

  private removeHoliday(index: number) {
    this.holidays.splice(index, 1);
  }

  private formatDate(day: Date) {
    const formatDay = new Date(day);
    const year = formatDay.getFullYear();
    const month = formatDay.getMonth() + 1;
    const d = formatDay.getDate();
    return `${year}年${month}月${d}日`;
  }

  // TODO: message 追加
  private form: UpdateRestaurant = {
    name: "",
    representativeName: "",
    representativeNameFurigana: "",
    email: "",
    password: undefined,
    phoneNumber: "",
    orderingPhoneNumber: "",
    deliverable: false,
    takeoutable: false,
    useHakobune: false,
    onlineOrderableTime: "",
    acceptableTime: "",
    minOrderAmount: "",
    address: {
      postalCode: "",
      prefecture: "",
      city: "",
      addressLine1: "",
      addressLine2: undefined,
    },
    genres: [],
    ugcUuid: undefined,
    hidden: false,
    edAcceptableTime: {},
    edOnlineOrderableTime: {},
    restaurantHolidays: [],
  };

  private checkedGenres: boolean[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private file: any = null;

  private fileUrl: string | ArrayBuffer | null = null;

  private get editStatus() {
    return EditStatus;
  }

  private get currentEditStatus() {
    return RestaurantModule.editStatus;
  }

  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private onFileChange(e: any) {
    const files = e.target.files || e.dataTransfer.files;
    // eslint-disable-next-line prefer-destructuring
    this.file = files[0];
    this.createImage(files[0]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private createImage(file: any) {
    const reader = new FileReader();
    reader.onload = e => {
      if (e.target && e.target.result) {
        this.fileUrl = e.target.result;
      }
    };
    return reader.readAsDataURL(file);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async uploadUGC(file: any) {
    try {
      const res = await UGCsApi.instance.createUGC(file);
      if (res.data.data?.ugc) {
        return res.data.data.ugc;
      }
      throw Error("Upload failed");
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      throw err;
    }
  }

  private confirm() {
    this.form.edAcceptableTime = this.edFormAcceptable;
    this.form.edOnlineOrderableTime = this.edFormOrderable;
    this.form.restaurantHolidays = this.holidays;
    RestaurantModule.commitEditStatus(EditStatus.Confirm);
    window.scrollTo(0, 0);
    this.form.genres = [];
    this.checkedGenres.forEach((bool: boolean | null, index: number) => {
      if (bool) {
        const findedGenre = this.genres.find(genre => genre.id === index);
        if (!findedGenre) {
          return;
        }
        if (!this.form.genres) {
          this.form.genres = [];
        }
        this.form.genres.push(findedGenre);
      }
    });
  }

  private async submit() {
    try {
      if (typeof this.me?.uuid !== "string") {
        return;
      }
      const rBody = Object.assign(this.form);
      if (!rBody.password) {
        delete rBody.password;
      }
      if (this.file) {
        const ugc = await this.uploadUGC(this.file);
        if (ugc.uuid) {
          rBody.ugcUuid = ugc.uuid;
        }
      }
      // eslint-disable-next-line prettier/prettier
      const restaurantRes = await RestaurantsApi.instance.updateRestaurantByUuid(this.me.uuid, rBody);
      if (!restaurantRes?.data?.data?.restaurant) {
        return;
      }
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  }

  private backEdit() {
    RestaurantModule.commitEditStatus(EditStatus.Edit);
    window.scrollTo(0, 0);
  }

  private autoComplete() {
    console.log("complete");
  }

  private get prefectures() {
    return Prefectures;
  }

  // ここからモーダル//
  private testShow() {
    (this.$refs.test as FormModal).CtestShow();
    this.submit();
  }
  // ここまでモーダル//

  private addAcceptableForm(key: string) {
    const timeForm = {
      start: null,
      end: null,
    };
    this.edFormAcceptable[key].push(timeForm);
  }

  private removeAcceptableForm(key: string, index: number) {
    this.edFormAcceptable[key].splice(index, 1);
  }

  private addOrderableForm(key: string) {
    const timeForm = {
      start: null,
      end: null,
    };
    this.edFormOrderable[key].push(timeForm);
  }

  private removeOrderableForm(key: string, index: number) {
    this.edFormOrderable[key].splice(index, 1);
  }
}
